'use strict';
const angular = require('angular');

export class mailComposerSendComponent {
  /*@ngInject*/
  constructor(RecipientListService, MailsService) {

    this.RecipientListService = RecipientListService;
    this.MailsService = MailsService;

    this.RecipientListService.query((data) => {
      this.recipientLists = data;
    }, err => {
      console.log("Could not retrieve recipient lists from server.")
    })

  }

  $onInit = function () {
    this.config = this.resolve.config;
  };

  ok(recipientListId) {

    let mail = this.config.mail;

    mail.recipients = this.getRecipients(recipientListId);

    this.MailsService.send({id: mail._id}, mail, (res) => {
      this.close({$value: {mailId: mail._id, archiveCategory: this.category}});
    }, (err) => {
      console.log("Could not send mail");
    });
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

  getDescription(id) {
    let idx = this.recipientLists.findIndex(o => o._id == id);
    return this.recipientLists[idx].description;
  }

  getRecipients(ids) {
    let recipients = [];

    ids.forEach(id => {
      let idx = this.recipientLists.findIndex(o => o._id == id);
      recipients = recipients.concat(this.recipientLists[idx].recipients);
    });

    return recipients;
  }

}

export default angular.module('conduApp.mailComposerSendComponent', [])
  .component('mailComposerSendComponent', {
    template: require('./mail-composer-send.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: mailComposerSendComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/mail-composer/send/mail-composer-send.component.js